<template>
  <div class="ConnectionsViewHint">
    <div class="content">
      <div class="content__header">
        Lista zarejestrowanych połączeń i możliwości
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            1
          </div>
        </div>
        <label>
          Możesz odsłuchać, zapisać rozmowę
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            2
          </div>
        </div>
        <label>
          Możesz skomentować jakość połączenia i zostawić notatkę
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            3
          </div>
        </div>
        <label>
          Możesz dowiedzieć się, w którym miejscu klient kliknął widget
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            4
          </div>
        </div>
        <label>
          Masz możliwość sprawdzenia i monitorowania historii połączeń
        </label>
      </div>
      <div class="content__row">
        <div class="content__point">
          <div class="point__number">
            5
          </div>
        </div>
        <label>
          Masz możliwość nagrywania każdej rozmowy, a pliki do pobrania będą dostępne przez 6 miesięcy od dnia połączenia
        </label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConnectionsViewHint',


};
</script>
